module.exports = __webpack_public_path__ + "img/quest_desc_robot.fdd41f70.svg";